{
  "version": 1,
  "asset_id": "0ad2814f-5185-49d7-9e2c-a8a67db1e5ef",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/0ad2814f-5185-49d7-9e2c-a8a67db1e5ef/hiatal-type-2-es-v3-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/0ad2814f-5185-49d7-9e2c-a8a67db1e5ef/hiatal-type-2-es-v3-800.webp",
  "original_filename": "hiatal-type-2-es-v3-800.webp",
  "size": 81452,
  "content_type": "image/webp",
  "created_at": "2026-10-28T19:42:30Z"
}
